/* tslint:disable */

/**
 */
export class BusStationFromApp {
    companyId?: number;
    partnerCode?: string;
    dataHash?: string;
}
